
import VueSlickCarousel from 'vue-slick-carousel'
import { Component, Vue, namespace, Prop, Emit } from 'nuxt-property-decorator'
import { namespace as offerStore, OfferState } from '~/store/modules/Offer'
import ProviderRatingCard from '~/components/providers/ProviderRatingCard.vue'
import { OnMounted } from '~/core/vue.types'
import { Provider } from '~/core/offer.types'

@Component({
  components: {
    VueSlickCarousel,
    ProviderRatingCard,
  },
})
export default class ProviderRatingCarousel extends Vue implements OnMounted {
  @Prop({ required: false, default: -1 }) readonly selectedProvider!: number
  @Prop({ required: true, default: () => ([]), type: Array })
  private readonly providersList!: Provider[]

  private settings = {
    dots: false,
    infinite: true,
    speed: 200,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerPadding: '0px',
    centerMode: true,
    swipeToSlide: true,
    focusOnSelect: false,
    initialSlide: 1,
    responsive: [
      {
        breakpoint: 1299,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          centerMode: true,
          dots: false,
          initialSlide: 0,
        },
      },
    ],
  }

  private isMounted = false

  @Emit()
  onSlideChange (slideIdx: number) {
    return slideIdx
  }

  @Emit()
  onCTAClick (slug: string) {
    return slug
  }

  setSlideTo (index: number) {
    // TODO: Typing for goTo()
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.$refs.ratingsCarousel.goTo(index)
  }

  mounted () {
    this.isMounted = true

    if (this.selectedProvider === -1) { return }
    const index = this.providersList.map(p => p.pk).indexOf(this.selectedProvider)

    if (index === -1) { return }

    this.$nextTick(() => {
      this.setSlideTo(index)
      this.onSlideChange(index)
    })
  }
}
